export default __webpack_public_path__ + "static/media/bahcekentImg.7cab6a98.jpg";